import React from "react";
import { FormProvider, useForm } from "react-hook-form";

export const FormWrapper = ({
  children = <></>,
  defaultValues,
  reValidateMode = "onChange",
  formMethodsProps,
}) => {
  const formMethods = formMethodsProps
    ? formMethodsProps
    : useForm({
        mode: "all",
        reValidateMode,
        defaultValues,
      });

  if (!formMethods) return null;
  return (
    <FormProvider {...formMethods}>
      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child, { formMethods })
          : child
      )}
    </FormProvider>
  );
};
